<div class="smart-consent-section">
  <!-- Proof of Ownership section for landlords -->
  @if (relationshipType === 'landlord') {
    <div class="proof-ownership-section">
      <h5>Proof of Ownership</h5>
      <p class="audit-notice">
        Please note that we conduct random audits to verify ownership and may require you to provide us with a copy of your Title register, which you can download from the Land Registry.
      </p>
    </div>
  }
  
  <!-- Granularity Selection -->
  <div class="granularity-section">
    <h5>Granularity</h5>
    <p>At what level of granularity would you like to access our smart meter data?</p>
    
    <mat-radio-group [value]="scopeControl.value" (change)="onGranularityChange($event)">
      <mat-radio-button value="ANNUAL">Annual (or) Monthly</mat-radio-button>
      <mat-radio-button value="HH">Half-hourly</mat-radio-button>
    </mat-radio-group>
  </div>

  <!-- Annual Granularity - Terms Acceptance -->
  @if (scopeControl.value === 'ANNUAL') {
    <div class="annual-consent-section">
      <app-add-checkbox-consent [formControl]="annualCheckboxConsentControl">
        By proceeding you agree to our 
        <a href="https://www.perse.io/terms" target="_blank">Terms & Conditions</a> 
        and 
        <a href="https://www.perse.io/privacy" target="_blank">Privacy Policy</a> 
        which include retrieving your current and historical energy information.
      </app-add-checkbox-consent>
    </div>
  }

  <!-- Half-hourly Granularity - Use Smart Meter Agreement Component -->
  @if (scopeControl.value === 'HH') {
    <div class="half-hourly-section">
      <app-smart-meter-agreement
        [selectedMeters]="selectedMeters"
        [formControl]="smartMeterAgreementControl"
        (triggerAutoScroll)="triggerAutoScrollEvent()">
      </app-smart-meter-agreement>

      <!-- Consent Method Section - Only show when agreement is complete -->
      @if (canShowConsentMethods()) {
        <div class="smart-meter-section">
          <h5>Consent Method</h5>
          <p>
            You have selected one or more smart meters. Please choose how you would like to provide consent for accessing your smart meter data:
          </p>
          @if (supportedSmartMeterConsentTypes.length === 0) {
            <div class="no-consent-methods">
              <mat-icon>error_outline</mat-icon>
              <p>No smart meter consent methods are currently supported. Please contact support.</p>
            </div>
          } @else {
            <app-smart-consent-options
              [supportedSmartMeterConsentTypes]="supportedSmartMeterConsentTypes"
              [selectedMeters]="selectedMeters"
              [moveInDate]="getEffectiveMoveInDate()"
              [termsAccepted]="getEffectiveTermsAccepted()"
              [useRadioButtons]="true"
              [formControl]="consentDataControl">
            </app-smart-consent-options>
          }
        </div>
      }
    </div>
  }
</div>
